import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux'
import { Form, InputGroup, Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { getRequest, downloadFile } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import CustomAlert from '../CustomAlert';
import searchIcon from '../../assets/SidebarIcons/icon-search.svg';
import { titleCase } from '../../helpers/helperFunction';

const ActivityLog = () => {
    const { access_token } = useSelector((state) => state.auth.user)
    const [loadingData, setLoadingData] = useState(false);
    const [search, setSearch] = useState('');
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);

    const [alertState, setAlertState] = useState({
        show: false,
        variant: 'danger',
        message: '',
    });

    const fetch_data = () => {
        setLoadingData(true);
        const requestData = { headers: { Authorization: access_token.token } };
        getRequest(`/admin/activity-log`, requestData, (res) => {
            if (res.success) {
                const result = res.data;
                const processedResult = result.map(item => ({
                    ...item,
                    details: typeof item.details === 'string' ? JSON.parse(item.details) : item.details
                }));
                setData(result);
                generateColumns(processedResult);
            }
            setLoadingData(false);
        });
    };

    const handleDownload = () => {
        downloadFile({
            url: '/admin/activity-log-export',
            data: { data: data },
            access_token: access_token,
            fileName: `activity-log.csv`,
        });
    };

    const generateColumns = (data) => {
        if (data.length <= 0) return;
        const columns = [
            {
                name: 'Email',
                width: '300px',
                selector: row => row.primary_email,
                sortable: true,
            },
            {
                name: 'Activity Type',
                width: '150px',
                selector: row => titleCase(row.activity_type.replace('_', ' ')),
                sortable: true,
            },
            {
                name: 'Created At',
                width: '130px',
                selector: row => row.created_at,
                sortable: true,
            },
            {
                name: 'Details',
                width: '666px',
                cell: row => {
                    switch (row.activity_type) {
                        case 'user_created':
                            return `${row.details.name} (${row.details.email}) Created by: ${row.details.created_by}`;
                        case 'campaign_created':
                            return `${row.details.name} (Total sent: ${row.details.total_sent})`;
                        case 'credit_transferred':
                            return `From: ${row.details.sender_email}, To: ${row.details.receiver_email}, Amount: ${row.details.credit}`;
                        default:
                            return JSON.stringify(row.details);
                    }
                },
                sortable: false,
            },
        ];
        setColumns(columns);
    };

    const filteredData = useMemo(() => {
        return data.filter((item) =>
            (item.details.name && item.details.name.toLowerCase().includes(search.toLowerCase())) ||
            (item.details.email && item.details.email.toLowerCase().includes(search.toLowerCase())) ||
            (item.primary_email && item.primary_email.toLowerCase().includes(search.toLowerCase())) ||
            (item.activity_type && item.activity_type.toLowerCase().includes(search.toLowerCase())) ||
            (item.created_at && item.created_at.toLowerCase().includes(search.toLowerCase()))
        );
    }, [data, search]);

    const onSearch = (evt) => {
        setSearch(evt.target.value);
    };

    useEffect(() => {
        fetch_data();

    }, []);

    useEffect(() => {
        if (alertState.show) {
            setTimeout(() => {
                setAlertState({
                    message: '',
                    show: false,
                    variant: '',
                });
            }, config.notify_time);
        }
    }, [alertState]);

    return (
        <div className="w-100" >
            <div className="page-heading admin-heading">
                <div className="container-left" style={{ marginBottom: "32px" }}>
                    <div className="page-title">Activity Log</div>
                </div>
                <div className="container-right mt-0">
                    <InputGroup className="datatable-search search-input">
                        <InputGroup.Append>
                            <InputGroup.Text>
                                <img alt="..." src={searchIcon} />
                            </InputGroup.Text>
                        </InputGroup.Append>
                        <Form.Control
                            placeholder="Search..."
                            name="search"
                            value={search}
                            onChange={onSearch}
                            className="search-form"
                        />
                    </InputGroup>

                    <Button
                        variant="primary"
                        disabled={loadingData}
                        style={{ minWidth: 160 }}
                        onClick={handleDownload}
                    >
                        Export to Excel
                    </Button>
                </div>
            </div>
            <CustomAlert
                message={alertState.message}
                show={alertState.show}
                variant={alertState.variant}
                closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
            />
            <DataTable
                columns={columns}
                data={filteredData}
                paginationComponentOptions={{
                    rowsPerPageText: 'Items per page:',
                }}
                pagination
                progressPending={loadingData}
            />
        </div>
    );
};

export default ActivityLog;
